export enum UserRole {
    Member = '1',
    Company = '2',
    Admin = '3'
}

export enum UserRoleIds {
    Member = 1,
    Company = 2,
    Admin = 3
}